// This is now our single source of truth for all car data
export const allCars = [
  { 
    id: "mercedes-1",
    name: "Mercedes", type: "Sedan", price: "125", image: "/assets/mercedes-1.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "5.2k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  { 
    id: "mercedes-2",
    name: "Mercedes", type: "Sport", price: "150", image: "/assets/mercedes-2.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 2, ac: "Yes", seats: 2, distance: "3.8k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "Sport Mode"]
  },
  { 
    id: "mercedes-3",
    name: "Mercedes", type: "SUV", price: "145", image: "/assets/mercedes-3.png",
    specs: { gearbox: "Automat", fuel: "Diesel", doors: 4, ac: "Yes", seats: 5, distance: "8.1k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "4x4"]
  },
  { 
    id: "bmw-1",
    name: "BMW", type: "Sport", price: "140", image: "/assets/bmw-1.png",
    specs: { gearbox: "Manual", fuel: "Petrol", doors: 2, ac: "Yes", seats: 2, distance: "4.5k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "Sport Exhaust"]
  },
  { 
    id: "toyota-1",
    name: "Toyota", type: "Truck", price: "135", image: "/assets/toyota-1.png",
    specs: { gearbox: "Manual", fuel: "Diesel", doors: 4, ac: "Yes", seats: 5, distance: "10.2k" },
    equipment: ["ABS", "Air Bags", "Towing Package"]
  },
  { 
    id: "bmw-2",
    name: "BMW", type: "Sedan", price: "150", image: "/assets/bmw-2.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "2.2k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "Sunroof"]
  },
  { 
    id: "mercedes-4",
    name: "Mercedes", type: "Coupé", price: "160", image: "/assets/mercedes-4.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 2, ac: "Yes", seats: 4, distance: "3.1k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  { 
    id: "toyota-2",
    name: "Toyota", type: "SUV", price: "150", image: "/assets/toyota-2.png",
    specs: { gearbox: "Automat", fuel: "Hybrid", doors: 4, ac: "Yes", seats: 5, distance: "1.5k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "Hybrid Tech"]
  },
  { 
    id: "maybach-1",
    name: "Maybach", type: "Van", price: "170", image: "/assets/mercedes-5.png",
    specs: { gearbox: "Automat", fuel: "Diesel", doors: 4, ac: "Yes", seats: 7, distance: "4.0k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "Luxury Seating"]
  },
  { 
    id: "audi-1",
    name: "Audi", type: "Sport", price: "145", image: "/assets/audi-1.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 2, ac: "Yes", seats: 2, distance: "2.8k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner", "Quattro"]
  },
  { 
    id: "audi-2",
    name: "Audi", type: "Sedan", price: "130", image: "/assets/audi-2.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "5.0k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  { 
    id: "ford-1",
    name: "Ford", type: "Truck", price: "125", image: "/assets/ford-1.png",
    specs: { gearbox: "Automat", fuel: "Diesel", doors: 4, ac: "Yes", seats: 5, distance: "9.5k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "4x4", "Towing Package"]
  },
  {
    id: "volkswagen-1",
    name: "Volkswagen", type: "Hatchback", price: "110", image: "/assets/volkswagen-1.png",
    specs: { gearbox: "Manual", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "6.3k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  {
    id: "hyundai-1",
    name: "Hyundai", type: "Sedan", price: "115", image: "/assets/hyundai-1.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "4.7k" },
  },
  {
    id: "volkswagen-2",
    name: "Volkswagen", type: "SUV", price: "120", image: "/assets/volkswagen-2.png",
    specs: { gearbox: "Automat", fuel: "Diesel", doors: 4, ac: "Yes", seats: 5, distance: "5.0k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  {
    id: "hyundai-2",
    name: "Hyundai", type: "Hatchback", price: "105", image: "/assets/hyundai-2.png",
    specs: { gearbox: "Manual", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "7.1k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  {
    id: "hyundai-3",
    name: "Hyundai", type: "SUV", price: "130", image: "/assets/hyundai-3.png",
    specs: { gearbox: "Automat", fuel: "Diesel", doors: 4, ac: "Yes", seats: 5, distance: "3.9k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  },
  {
    id: "volkswagen-4",
    name: "Volkswagen", type: "Sedan", price: "115", image: "/assets/volkswagen-4.png",
    specs: { gearbox: "Automat", fuel: "Petrol", doors: 4, ac: "Yes", seats: 5, distance: "4.4k" },
    equipment: ["ABS", "Air Bags", "Cruise Control", "Air Conditioner"]
  }

  // Add the rest of your cars here following the same format...
];